/** `/c/$companyId/journals/stock-count` — a stock count: the stock's value on a date, the difference posted. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { StockCountScreen } from "../journals/StockCountScreen";

export const Route = createFileRoute("/_auth/c/$companyId/journals/stock-count")({
  component: StockCount,
});

function StockCount(): JSX.Element {
  const { companyId } = Route.useParams();
  return <StockCountScreen companyId={companyId} />;
}
